import { AppButton } from '@app/shared/components/AppButton';
import { withEditPermissionCheck } from '@app/shared/hocs/withEditPermissionCheck';

export const RoleProtectedButton = withEditPermissionCheck(AppButton);
